'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _TypeEditor = require('./TypeEditor');

var _TypeEditor2 = _interopRequireDefault(_TypeEditor);

var _lodash = require('lodash');

var _reactFulcrum = require('@upgrowth/react-fulcrum');

var _TypeContext = require('./TypeContext');

var _AddOptions = require('../components/AddOptions');

var _AddOptions2 = _interopRequireDefault(_AddOptions);

var _Layout = require('../layouts/Layout');

var _Layout2 = _interopRequireDefault(_Layout);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = (0, _TypeContext.withTypes)(function (_ref) {
  var name = _ref.name,
      type = _ref.type,
      context = _ref.context,
      resolveType = _ref.resolveType;
  var value = context.value,
      current = context.current,
      path = context.path,
      labels = context.labels,
      onChange = context.onChange;
  var description = type.description,
      label = type.label,
      _type$variant = type.variant,
      variant = _type$variant === undefined ? "none" : _type$variant,
      layout = type.layout,
      of = type.of;

  if (!(0, _lodash.isObject)(value)) {
    value = {};
  }

  var imValue = (0, _immutable.OrderedMap)(value);

  var onAdd = function onAdd(childType) {
    var key = window.prompt("What is the unique id?");

    if (key) {
      var _current = imValue.get(key);

      var initialValue = _current || childType.defaultValue || {};
      onChange(path, imValue.set(key, {
        type: childType.name,
        value: initialValue
      }).toJS());
    }
  };

  var onDelete = function onDelete(key) {
    return window.confirm('Delete ' + key + ' ?') && onChange(path, imValue.delete(key).toJS());
  };

  var options = (0, _lodash.map)(of, function (option, key) {
    return (0, _extends3.default)({}, resolveType(option), {
      name: key
    });
  });
  var outerLabel = label;
  return _react2.default.createElement('div', {
    className: 'CollectionEditor variant-' + variant
  }, _react2.default.createElement(_Layout2.default, {
    layout: layout,
    onAdd: onAdd,
    onRemove: onDelete,
    addOptions: _react2.default.createElement(_AddOptions2.default, {
      options: options,
      onAdd: onAdd
    }),
    values: (0, _lodash.map)(value, function (slot, key) {
      var nestedPath = [].concat((0, _toConsumableArray3.default)(path), [key, 'value']);
      var nestedType = type.of && type.of[slot.type] || slot.type;
      nestedType = resolveType(nestedType);

      var _ref2 = nestedType || {},
          _ref2$label = _ref2.label,
          label = _ref2$label === undefined ? slot.type : _ref2$label,
          description = _ref2.description;

      return {
        key: key,
        type: nestedType,
        dirty: (0, _Layout.isDirty)((0, _lodash.get)(value, [key]), (0, _lodash.get)(current, [key])),
        label: key,
        el: !nestedType ? _react2.default.createElement('div', null, nestedType, ' not found') : _react2.default.createElement(_reactFulcrum.Field, {
          key: key,
          name: key,
          label: outerLabel + ' ' + key + ' - ' + label,
          description: description,
          className: 'child'
        }, _react2.default.createElement(_TypeEditor2.default, {
          name: key,
          type: nestedType,
          context: (0, _extends3.default)({}, context, {
            path: nestedPath,
            labels: [].concat((0, _toConsumableArray3.default)(labels), [label]),
            current: ((current || {})[key] || {}).value,
            value: slot.value,
            onChange: onChange
          })
        }))
      };
    })
  }));
});